import {MutationTree} from 'vuex'
import {IBMState} from './bm-state.store'
import * as types from './bm-types.store'
import {ActivityStatus, CrudStatus} from '../../common/enums'
import {
  IBMMeetingListingViewModel,
  IBMDetailViewModel,
  BMParameter,
  IBMListingViewModel,
  BMEditedViewModel
} from '../../models/bm/index'
import {Pagination} from '../../models/generic'
import {IBMMeetingDetailViewModel} from "../../models/bm/bm-meeting-detail.viewmodel";
import {APARTMENT_ACTION} from "../apartment";
import {IApartmentState} from "../apartment/apartment-state.store";
import {BM_ACTION, BM_CURRENT_BM, BM_EDIT_BM, BM_EDIT_BM_BY_FIELD, BM_EDIT_MEETING_BY_FIELD} from "./bm-types.store";

export const mutations: MutationTree<IBMState> = {
  [types.BM_GET_BMS_LOADING]: (state: IBMState, activityStatus: ActivityStatus) => {
    state.bmsSource.activityStatus = activityStatus
  },
  [types.BM_GET_BM_LOADING]: (state: IBMState, activityStatus: ActivityStatus) => {
    state.bmSource.activityStatus = activityStatus
  },
  [types.BM_GET_BM_MEETINGS_LOADING]: (state: IBMState, activityStatus: ActivityStatus) => {
    state.bmMeetings.activityStatus = activityStatus
  },

  [types.BM_GET_BMS]: (state: IBMState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    bms: any[],
    pagination?: any
  }) => {
    if (payload.merge === false) {
      state.bmsSource.data = payload.bms
    } else {
      const bms = state.bmsSource.data || []
      const uniqueBMs = payload.bms.filter((item) => {
        return bms.findIndex(t => t.id === item.id) === -1
      })
      state.bmsSource.data = bms.concat(uniqueBMs)
    }

    state.bmsSource.activityStatus = payload.activityStatus

    if (payload.pagination) {
      state.pagination = payload.pagination
    }
  },
  [types.BM_GET_BM_MEETINGS]: (state: IBMState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    meetings: any[],
    pagination?: any
  }) => {
    if (payload.merge === false) {
      state.bmMeetings.data = payload.meetings
    } else {
      const meetings = state.bmMeetings.data || []
      const uniqueMeetings = payload.meetings.filter((item) => {
        return meetings.findIndex(t => t.id === item.id) === -1
      })
      state.bmMeetings.data = meetings.concat(uniqueMeetings)
    }

    state.bmMeetings.activityStatus = payload.activityStatus

    if (payload.pagination) {
      state.pagination = payload.pagination
    }
  },
  [types.BM_GET_BM]: (state: IBMState,
                        detail: IBMDetailViewModel) => {
    state.bmSource = {
      activityStatus: ActivityStatus.Loaded,
      detail: detail
    }
  },
  /*[types.BM_GET_BM_MEETINGS]: (state: IBMState,
                                 data: IBMMeetingListingViewModel[]) => {
    state.bmMeetings = {
      activityStatus: ActivityStatus.Loaded,
      data: data
    }
  },*/
  [types.BM_GET_MEETING]: (state: IBMState,
                             data: IBMMeetingDetailViewModel) => {
    state.bmMeeting = {
      activityStatus: ActivityStatus.Loaded,
      data: data
    }
  },
  [types.BM_GET_MEETING_PLAN]: (state: IBMState,
                             data: any[]) => {
    state.bmMeetingPlan = data
  },
  [types.BM_SET_VALUE_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmParameter = {
      ...state.bmParameter,
      ...payload
    }
  },
  [types.BM_EDIT_PARTICIPANT_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmParticipantEdited = {
      ...state.bmParticipantEdited,
      ...payload
    }
  },
  [types.BM_MEETING_SET_VALUE_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmMeetingParameter = {
      ...state.bmMeetingParameter,
      ...payload
    }
  },
  [types.BM_EDIT_IB_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmIBEdited = {
      ...state.bmIBEdited,
      ...payload
    }
  },
  [types.BM_EDIT_PLAN_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmPlanEdited = {
      ...state.bmPlanEdited,
      ...payload
    }
  },
  [types.BM_EDIT_CONTRACTOR_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmContractorEdited = {
      ...state.bmContractorEdited,
      ...payload
    }
  },
  [types.BM_EDIT_COMMENT_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmCommentEdited = {
      ...state.bmCommentEdited,
      ...payload
    }
  },
  [types.BM_EDIT_MARKER_BY_FIELD]: (state: IBMState,
                                    payload: { [key: string]: any }) => {
    state.bmMarkerEdited = {
      ...state.bmMarkerEdited,
      ...payload
    }
  },
  [types.BM_RESET_BMS]: (state: IBMState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    tickets: any[],
    pagination?: any
  }) => {
    state.bmParameter = new BMParameter()
    state.pagination = new Pagination({total: 0, limit: 0, skip: 0})
    state.bmsSource.data = []
    state.bmsSource.activityStatus = ActivityStatus.NoActivity
  },
  [types.BM_SET_LOADER_STATE]: (state: IBMState, payload: { key: string, value: boolean }) => {
    state.loaders = new Map([
      ...state.loaders,
      [payload.key, payload.value]
    ])
  },
  [types.BM_RESET_BM_MEETINGS]: (state: IBMState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    bmMeetings: any[],
    pagination?: any
  }) => {
    state.bmParameter = new BMParameter()
    state.pagination = new Pagination({total: 0, limit: 0, skip: 0})
    state.bmMeetings.data = []
    state.bmMeetings.activityStatus = ActivityStatus.NoActivity
  },
  [BM_ACTION] : (state: IBMState, crudAction: CrudStatus) => {
    state.crudActionStatus = crudAction
  },
  [BM_EDIT_BM_BY_FIELD]: (state: IBMState, payload: { [key: string]: any }) => {
    state.bmEdited = {
      ...state.bmEdited,
      ...payload
    }
  },
  [BM_EDIT_MEETING_BY_FIELD]: (state: IBMState, payload: { [key: string]: any }) => {
    state.bmMeetingEdited = {
      ...state.bmMeetingEdited,
      ...payload
    }
  },
  [BM_CURRENT_BM]: (state: IBMState, data: IBMListingViewModel) => {
    state.bmCurrent = data
  }
}



// WEBPACK FOOTER //
// ./src/store/building-monitor/bm-mutations.store.ts